export const CRITERIA_APPARTEMENT = {
  exterieur: {
    label: '🌿 Extérieur',
    options: [
      { value: 'terrasse', label: 'Terrasse' },
      { value: 'balcon', label: 'Balcon' },
      { value: 'aucun', label: 'Aucun' }
    ]
  },
  exposition: {
    label: '🧭 Exposition',
    options: [
      { value: 'nord', label: 'Nord' },
      { value: 'est', label: 'Est' },
      { value: 'sud', label: 'Sud' },
      { value: 'ouest', label: 'Ouest' }
    ]
  },
  parking: {
    label: '🚗 Parking et Cave',
    options: [
      { value: 'garage', label: 'Garage' },
      { value: 'place-parking', label: 'Place de parking' },
      { value: 'parking-souterrain', label: 'Parking sous-sol' },
      { value: 'cave', label: 'Cave' },
      { value: 'aucun', label: 'Aucun' }
    ]
  },
  etage: {
    label: '🏭 Étage',
    options: [
      { value: 'rdc', label: 'Rez-de-chaussée' },
      { value: '1er', label: '1er étage' },
      { value: '2eme', label: '2ème étage' },
      { value: '3eme-plus', label: '3ème étage ou plus' },
      { value: 'dernier', label: 'Dernier étage' }
    ]
  },
  etat: {
    label: '🔨 État',
    options: [
      { value: 'neuf', label: 'Neuf' },
      { value: 'excellent', label: 'Excellent état' },
      { value: 'bon', label: 'Bon état' },
      { value: 'a-rafraichir', label: 'À rafraîchir' },
      { value: 'travaux', label: 'Travaux nécessaires' }
    ]
  },
  equipements: {
    label: '⚙️ Équipements',
    options: [
      { value: 'ascenseur', label: 'Ascenseur' },
      { value: 'cuisine-equipee', label: 'Cuisine équipée' },
      { value: 'fibre', label: 'Fibre optique' },
      { value: 'gardien', label: 'Gardien' },
      { value: 'digicode', label: 'Digicode' },
      { value: 'vue-mer', label: 'Vue mer' }
    ]
  },
  proximite: {
    label: '📍 Proximité',
    options: [
      { value: 'commerces', label: 'Commerces' },
      { value: 'ecoles', label: 'Écoles' },
      { value: 'transports', label: 'Transports en commun' },
      { value: 'plage', label: 'Plage' },
      { value: 'centre', label: 'Centre-ville' }
    ]
  },
  contraintes: {
    label: '🚫 Contraintes',
    options: [
      { value: 'calme', label: 'Calme obligatoire' },
      { value: 'lumineux', label: 'Très lumineux' },
      { value: 'sans-vis-a-vis', label: 'Sans vis-à-vis' },
      { value: 'charges-faibles', label: 'Charges <2€/m²' },
      { value: 'copro-recente', label: 'Copropriété récente' }
    ]
  }
};

export const CRITERIA_MAISON = {
  exterieur: {
    label: '🌿 Extérieur',
    options: [
      { value: 'terrasse', label: 'Terrasse' },
      { value: 'jardin', label: 'Jardin' },
      { value: 'piscine', label: 'Piscine' },
      { value: 'balcon', label: 'Balcon' }
    ]
  },
  exposition: {
    label: '🧭 Exposition',
    options: [
      { value: 'nord', label: 'Nord' },
      { value: 'est', label: 'Est' },
      { value: 'sud', label: 'Sud' },
      { value: 'ouest', label: 'Ouest' }
    ]
  },
  parking: {
    label: '🚗 Parking et Cave',
    options: [
      { value: 'garage', label: 'Garage' },
      { value: 'garage-double', label: 'Garage double' },
      { value: 'place-parking', label: 'Place de parking' },
      { value: 'cave', label: 'Cave' },
      { value: 'aucun', label: 'Aucun' }
    ]
  },
  niveaux: {
    label: '🏗️ Nombre de niveaux',
    options: [
      { value: 'plain-pied', label: 'Plain-pied' },
      { value: '1-etage', label: '1 étage' },
      { value: '2-etages', label: '2 étages' },
      { value: '3-etages-plus', label: '3 étages ou plus' }
    ]
  },
  terrain: {
    label: '🌳 Terrain',
    options: [
      { value: 'petit', label: 'Petit (<200m²)' },
      { value: 'moyen', label: 'Moyen (200-500m²)' },
      { value: 'grand', label: 'Grand (500-1000m²)' },
      { value: 'tres-grand', label: 'Très grand (>1000m²)' }
    ]
  },
  etat: {
    label: '🔨 État',
    options: [
      { value: 'neuf', label: 'Neuf' },
      { value: 'excellent', label: 'Excellent état' },
      { value: 'bon', label: 'Bon état' },
      { value: 'a-rafraichir', label: 'À rafraîchir' },
      { value: 'travaux', label: 'Travaux nécessaires' }
    ]
  },
  equipements: {
    label: '⚙️ Équipements',
    options: [
      { value: 'cuisine-equipee', label: 'Cuisine équipée' },
      { value: 'fibre', label: 'Fibre optique' },
      { value: 'portail-auto', label: 'Portail automatique' },
      { value: 'alarme', label: 'Alarme' },
      { value: 'vue-mer', label: 'Vue mer' },
      { value: 'piscine-chauffee', label: 'Piscine chauffée' }
    ]
  },
  proximite: {
    label: '📍 Proximité',
    options: [
      { value: 'commerces', label: 'Commerces' },
      { value: 'ecoles', label: 'Écoles' },
      { value: 'transports', label: 'Transports en commun' },
      { value: 'plage', label: 'Plage' },
      { value: 'centre', label: 'Centre-ville' }
    ]
  },
  contraintes: {
    label: '🚫 Contraintes',
    options: [
      { value: 'calme', label: 'Calme obligatoire' },
      { value: 'lumineux', label: 'Très lumineux' },
      { value: 'sans-vis-a-vis', label: 'Sans vis-à-vis' },
      { value: 'charges-faibles', label: 'Charges <2€/m²' },
      { value: 'mitoyennete-limitee', label: 'Mitoyenneté limitée' }
    ]
  }
};

export const getCriteriaForType = (propertyType) => {
  if (propertyType === 'Maison') {
    return CRITERIA_MAISON;
  }
  return CRITERIA_APPARTEMENT;
};

// Calcul distance entre deux points GPS (formule haversine)
function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 6371e3; // Rayon de la Terre en mètres
  const φ1 = lat1 * Math.PI / 180;
  const φ2 = lat2 * Math.PI / 180;
  const Δφ = (lat2 - lat1) * Math.PI / 180;
  const Δλ = (lon2 - lon1) * Math.PI / 180;

  const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
          Math.cos(φ1) * Math.cos(φ2) *
          Math.sin(Δλ/2) * Math.sin(Δλ/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

  return R * c; // Distance en mètres
}

export const calculateMatchScore = (acquirerAd, vendeurProposal) => {
  let totalPoints = 0;
  let matchedPoints = 0;

  // 1. Type de bien (priorité haute)
  if (acquirerAd.property_type && vendeurProposal.property_type) {
    totalPoints += 2;
    if (acquirerAd.property_type === vendeurProposal.property_type) {
      matchedPoints += 2;
    }
  }

  // 2. Nombre de pièces
  if (acquirerAd.rooms && vendeurProposal.rooms) {
    totalPoints += 2;
    if (parseInt(acquirerAd.rooms) === parseInt(vendeurProposal.rooms)) {
      matchedPoints += 2;
    } else if (Math.abs(parseInt(acquirerAd.rooms) - parseInt(vendeurProposal.rooms)) === 1) {
      matchedPoints += 1; // +/- 1 pièce = demi-point
    }
  }

  // 3. Surface
  if (acquirerAd.min_surface && vendeurProposal.surface) {
    totalPoints += 2;
    const surface = parseFloat(vendeurProposal.surface);
    const minSurface = parseFloat(acquirerAd.min_surface);
    const maxSurface = parseFloat(acquirerAd.max_surface || acquirerAd.min_surface * 1.5);
    
    if (surface >= minSurface && surface <= maxSurface) {
      matchedPoints += 2;
    } else if (surface >= minSurface * 0.9 && surface <= maxSurface * 1.1) {
      matchedPoints += 1; // Proche de la fourchette = demi-point
    }
  }

  // 4. Budget/Prix
  if (acquirerAd.max_budget && vendeurProposal.price) {
    totalPoints += 2;
    const price = parseFloat(vendeurProposal.price);
    const minBudget = parseFloat(acquirerAd.min_budget || 0);
    const maxBudget = parseFloat(acquirerAd.max_budget);
    
    if (price >= minBudget && price <= maxBudget) {
      matchedPoints += 2;
    } else if (price <= maxBudget * 1.1) {
      matchedPoints += 1; // Légèrement au-dessus = demi-point
    }
  }

  // 5. Localisation géographique (NOUVEAU)
  if (acquirerAd.location_data?.coords && acquirerAd.location_data?.radius && 
      vendeurProposal.location_data?.coords) {
    totalPoints += 3; // Haute priorité
    
    const [acqLat, acqLon] = acquirerAd.location_data.coords;
    const [vendLat, vendLon] = vendeurProposal.location_data.coords;
    const distance = calculateDistance(acqLat, acqLon, vendLat, vendLon);
    const searchRadius = acquirerAd.location_data.radius;
    
    if (distance <= searchRadius) {
      matchedPoints += 3; // Dans la zone
    } else if (distance <= searchRadius * 1.2) {
      matchedPoints += 1; // Proche de la zone
    }
  }

  // 6. Critères structurés
  if (acquirerAd.criteria && vendeurProposal.criteria) {
    Object.keys(acquirerAd.criteria).forEach(category => {
      const acqCrit = acquirerAd.criteria[category] || [];
      const vendCrit = vendeurProposal.criteria[category] || [];
      
      if (acqCrit.length === 0) return; // Neutre si acquéreur n'a rien coché
      
      acqCrit.forEach(criterion => {
        totalPoints += 1;
        if (vendCrit.includes(criterion)) {
          matchedPoints += 1;
        }
      });
    });
  }

  return totalPoints > 0 ? Math.round((matchedPoints / totalPoints) * 100) : 0;
};
